import * as Service$SolvuuApi0 from "solvuu-api0/./service.bs.js";
import * as Service_request_bs$SolvuuApi0 from "solvuu-api0/./service_request_bs.bs.js";
import * as Service_request_atd$SolvuuApi0 from "solvuu-api0/./service_request_atd.bs.js";
import * as Service_response_bs$SolvuuApi0 from "solvuu-api0/./service_response_bs.bs.js";
import * as Service_response_atd$SolvuuApi0 from "solvuu-api0/./service_response_atd.bs.js";
var $$Request = {
  Json: Service_request_bs$SolvuuApi0,
  json_of_api_version: Service_request_atd$SolvuuApi0.json_of_api_version,
  json_of_http_version: Service_request_atd$SolvuuApi0.json_of_http_version,
  json_of_http_method: Service_request_atd$SolvuuApi0.json_of_http_method,
  json_of_t: Service_request_atd$SolvuuApi0.json_of_t,
  api_version_of_json: Service_request_atd$SolvuuApi0.api_version_of_json,
  http_version_of_json: Service_request_atd$SolvuuApi0.http_version_of_json,
  http_method_of_json: Service_request_atd$SolvuuApi0.http_method_of_json,
  t_of_json: Service_request_atd$SolvuuApi0.t_of_json
};
var $$Response = {
  Json: Service_response_bs$SolvuuApi0,
  json_of_api_version: Service_response_atd$SolvuuApi0.json_of_api_version,
  json_of_http_version: Service_response_atd$SolvuuApi0.json_of_http_version,
  json_of_success: Service_response_atd$SolvuuApi0.json_of_success,
  json_of_client_error: Service_response_atd$SolvuuApi0.json_of_client_error,
  json_of_info: Service_response_atd$SolvuuApi0.json_of_info,
  json_of_t: Service_response_atd$SolvuuApi0.json_of_t,
  api_version_of_json: Service_response_atd$SolvuuApi0.api_version_of_json,
  http_version_of_json: Service_response_atd$SolvuuApi0.http_version_of_json,
  success_of_json: Service_response_atd$SolvuuApi0.success_of_json,
  client_error_of_json: Service_response_atd$SolvuuApi0.client_error_of_json,
  info_of_json: Service_response_atd$SolvuuApi0.info_of_json,
  t_of_json: Service_response_atd$SolvuuApi0.t_of_json
};
var path = Service$SolvuuApi0.path;
var Get_all = Service$SolvuuApi0.Get_all;
var Get_by_id = Service$SolvuuApi0.Get_by_id;
var Get_events = Service$SolvuuApi0.Get_events;
var Create = Service$SolvuuApi0.Create;
var failwith_unexpected_entity_in_path = Service$SolvuuApi0.failwith_unexpected_entity_in_path;
var failwith_unexpected_path = Service$SolvuuApi0.failwith_unexpected_path;
var Exn = Service$SolvuuApi0.Exn;
export { $$Request, $$Response, path, Get_all, Get_by_id, Get_events, Create, failwith_unexpected_entity_in_path, failwith_unexpected_path, Exn };
/* Service-SolvuuApi0 Not a pure module */